<template>
  <vue-modal name="InfoEq" :hideCloseBtn="true" :on-show="changeForm()">
    <modalImg ref="imgzoomC" :name="'modalImg2'" :arrImg="modalArr" />

    <div id="SerialComp" class="customDropd" style="">
      <div class="card mb-0">
        <div class="card-header">
          <h4 class="form-section">
            <i class="icon-info"></i> {{ modalComp.title }}
          </h4>
          <div class="heading-elements" style="">
            <button
              type="button"
              class="btn btn-warning"
              @click="closeSerCompon()"
            >
              <i style="color: #ffffff" class="icon-cross"></i>
            </button>
          </div>
        </div>
        <div class="card-body">
          <div class="mobileTbl table-responsive">
            <table class="table table-hover mb-0" cellspacing="0">
              <thead>
                <tr>
                  <th
                    class="text-truncate"
                    style="vertical-align: middle"
                    v-for="(name, col) in modalComp.header"
                    :key="col"
                  >
                    <span>{{ name }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in modalComp.data" :key="index">
                  <td
                    :data-title="name"
                    v-for="(name, col) in modalComp.header"
                    :key="col"
                  >
                    <span>{{ data[name] }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="card" style="border: none">
      <div class="card-header" style="border-bottom: none; padding: 1rem 0px">
        <h4 class="form-section">
          <i class="icon-info"></i> {{ $t("equipm.titles.about") }}
          {{ dataEquipment.serial }}
        </h4>
        <div class="heading-elements" style="right: 0px">
          <button
            type="button"
            class="btn btn-warning"
            @click="
              closingModal();
              $modals.hide('InfoEq');
            "
          >
            <i style="color: #ffffff" class="icon-cross"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <ul class="nav nav-tabs">
              <li
                class="nav-item"
                data-html="true"
                :title="$t('tasks.hint.detail') + ' ' + dataEquipment.serial"
              >
                <a
                  class="nav-link"
                  v-bind:class="{ active: dataEquipment.tabs.info }"
                  id="base-tab1"
                  data-toggle="tab"
                  @click="dataEquipment.tabs.info = true"
                >
                  <i class="icon-info"></i>
                </a>
              </li>
              <li
                class="nav-item"
                data-html="true"
                :title="$t('tasks.table.images')"
              >
                <a
                  class="nav-link"
                  v-bind:class="{ active: dataEquipment.tabs.photo }"
                  id="base-tab2"
                  data-toggle="tab"
                  @click="dataEquipment.tabs.photo = true"
                >
                  <i class="icon-images2"></i>
                </a>
              </li>
              <li
                class="nav-item"
                data-html="true"
                :title="$t('equipm.hint.files')"
              >
                <a
                  class="nav-link"
                  v-bind:class="{ active: dataEquipment.tabs.files }"
                  id="base-tab3"
                  data-toggle="tab"
                  @click="dataEquipment.tabs.files = true"
                >
                  <i class="icon-file-text2"></i>
                </a>
              </li>
              <li
                class="nav-item"
                data-html="true"
                :title="$t('tasks.titles.history')"
              >
                <a
                  class="nav-link"
                  v-bind:class="{ active: dataEquipment.tabs.history }"
                  id="base-tab4"
                  data-toggle="tab"
                  @click="dataEquipment.tabs.history = true"
                >
                  <i class="icon-history"></i>
                </a>
              </li>
            </ul>

            <div class="row" v-if="dataEquipment.tabs.info">
              <div
                class="col-md-6"
                :class="{
                  'offset-md-3': dataEquipment.ProductType != 'Refrigeration',
                }"
              >
                <div class="form-body">
                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-eye6"></i>
                      {{ $t("equipm.titles.details") }}
                    </h4>
                  </form>
                  <div class="form-group">
                    <label for="serial">{{
                      $t("equipm.table.serNumber")
                    }}</label>
                    <div class="position-relative has-icon-left">
                      <input
                        class="form-control border-primary"
                        type="text"
                        id="serial"
                        v-model="dataEquipment.serial"
                        disabled
                      />
                      <div class="form-control-position">
                        <i class="icon-qrcode"></i>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="nameEq">{{ $t("equipm.table.nameEq") }}</label>
                    <div
                      class="form-control border-primary"
                      style="background-color: #eceeef; min-height: 2em"
                    >
                      {{ dataEquipment.name }}
                    </div>
                  </div>
                  <div
                    class="form-group"
                    v-if="dataEquipment.ExternalName != null"
                  >
                    <label for="nameEq">{{ $t("equipm.table.extName") }}</label>
                    <div
                      class="form-control border-primary"
                      style="background-color: #eceeef; min-height: 2em"
                    >
                      {{ dataEquipment.ExternalName }}
                    </div>
                  </div>
                  <form class="form">
                    <h4 class="form-section">
                      <i class="icon-mail6"></i>
                      {{ $t("equipm.titles.infoAbManuf") }}
                    </h4>
                  </form>
                  <div class="form-group">
                    <label for="contacts">{{
                      $t("equipm.table.contacts")
                    }}</label>
                    <div class="position-relative has-icon-left">
                      <!--<input class="form-control border-primary" type="tel" placeholder="phone number" id="userinput5" pattern="[+]{1}[0-9]{11,14}" v-model="dataEquipment.contacts" disabled>-->
                      <textarea
                        id="contacts"
                        name="contacts"
                        rows="4"
                        class="form-control border-primary"
                        v-model="dataEquipment.contacts"
                        disabled
                      ></textarea>
                      <div class="form-control-position">
                        <i class="icon-address-book"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-md-6"
                v-if="dataEquipment.ProductType == 'Refrigeration'"
              >
                <div class="row">
                  <div class="col-md-12">
                    <form class="form">
                      <h4 class="form-section">
                        <i class="icon-file-text2"></i>
                        {{ $t("equipm.titles.characters") }}
                      </h4>
                    </form>

                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="climaticClass">{{
                            $t("equipm.table.clClass")
                          }}</label>
                          <div class="position-relative has-icon-left">
                            <input
                              type="text"
                              id="climaticClass"
                              class="form-control border-primary"
                              name="climaticClass"
                              v-model="dataEquipment.climaticClass"
                              disabled
                            />
                            <div class="form-control-position">
                              <i class="icon-brightness-contrast"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="defrosting">{{
                            $t("equipm.table.defrosting")
                          }}</label>
                          <div class="position-relative has-icon-left">
                            <input
                              type="text"
                              id="defrosting"
                              class="form-control border-primary"
                              name="defrosting"
                              v-model="dataEquipment.defrosting"
                              disabled
                            />
                            <div class="form-control-position">
                              <i class="icon-svg"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="maxPressure">{{
                            $t("equipm.table.maxPress")
                          }}</label>
                          <div class="position-relative has-icon-left">
                            <input
                              type="text"
                              id="maxPressure"
                              class="form-control border-primary"
                              name="maxPressure"
                              v-model="dataEquipment.maxPressure"
                              disabled
                            />
                            <div class="form-control-position">
                              <i class="icon-meter"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="protectionClass">{{
                            $t("equipm.table.protClass")
                          }}</label>
                          <div class="position-relative has-icon-left">
                            <input
                              type="text"
                              id="protectionClass"
                              class="form-control border-primary"
                              name="protectionClass"
                              v-model="dataEquipment.protectionClass"
                              disabled
                            />
                            <div class="form-control-position">
                              <i class="icon-security"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="ratedCurrent">{{
                            $t("equipm.table.currCons")
                          }}</label>
                          <div class="position-relative has-icon-left">
                            <input
                              type="text"
                              id="ratedCurrent"
                              class="form-control border-primary"
                              name="ratedCurrent"
                              v-model="dataEquipment.ratedCurrent"
                              disabled
                            />
                            <div class="form-control-position">
                              <i class="icon-power2"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="ratedPinp">{{
                            $t("equipm.table.pwrConsump")
                          }}</label>
                          <div class="position-relative has-icon-left">
                            <input
                              type="text"
                              id="ratedPinp"
                              class="form-control border-primary"
                              name="ratedPinp"
                              v-model="dataEquipment.ratedPinp"
                              disabled
                            />
                            <div class="form-control-position">
                              <i class="icon-power-cord"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-file-text"></i>
                    {{ $t("equipm.titles.specif") }}
                  </h4>
                </form>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="artcile">{{
                        $t("equipm.table.articule")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <input
                          type="text"
                          id="artcile"
                          class="form-control border-primary"
                          name="artcile"
                          v-model="dataEquipment.article"
                          disabled
                        />
                        <div class="form-control-position">
                          <i class="icon-price-tags"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="titleRefr">{{
                        $t("equipm.table.refrigerant")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <input
                          type="text"
                          id="titleRefr"
                          class="form-control border-primary"
                          name="titleRefr"
                          v-model="titleRefr"
                          disabled
                        />
                        <div class="form-control-position">
                          <i class="icon-lab"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="dtShipment">{{
                        $t("equipm.table.shipmDate")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <!--<input type="date" id="dtinput1" class="form-control" name="dtShipment" v-model="dataEquipment.dates.shipment" disabled>-->
                        <input
                          type="text"
                          id="dtShipment"
                          class="form-control"
                          name="dtShipment"
                          v-model="dataEquipment.dates.shipment"
                          disabled
                        />
                        <div class="form-control-position">
                          <i class="icon-calendar3"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="dtManufacturing">{{
                        $t("equipm.table.manufDate")
                      }}</label>
                      <div class="position-relative has-icon-left">
                        <input
                          type="text"
                          id="dtManufacturing"
                          class="form-control"
                          name="dtManufacturing"
                          v-model="dataEquipment.dates.manufacturing"
                          disabled
                        />
                        <div class="form-control-position">
                          <i class="icon-calendar3"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row"
              v-if="
                dataEquipment.components.length > 0 && dataEquipment.tabs.info
              "
            >
              <div class="col-md-12">
                <form class="form">
                  <h4 class="form-section mb-0">
                    <i class="icon-stack"></i>
                    {{ $t("equipm.titles.components") }}
                  </h4>
                </form>
                <div class="col-md-12">
                  <div class="mobileTbl table-responsive">
                    <table class="table table-hover mb-0" cellspacing="0">
                      <thead>
                        <tr>
                          <th style="vertical-align: middle">
                            {{ $t("equipm.table.nameEq") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("equipm.table.serNumber") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("equipm.table.count") }}
                          </th>
                          <th style="vertical-align: middle">
                            {{ $t("equipm.table.manufacturer") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in dataEquipment.components"
                          :key="index"
                        >
                          <td :data-title="$t('equipm.table.nameEq')">
                            {{ item.Item }}
                          </td>
                          <td :data-title="$t('equipm.table.serNumber')">
                            <a @click="showComponDetail($event, item)">{{
                              item.ItemSN
                            }}</a>
                          </td>
                          <td :data-title="$t('equipm.table.count')">
                            {{ item.Quantity }}
                          </td>
                          <td :data-title="$t('equipm.table.manufacturer')">
                            {{ item.Manufacturer }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="dataEquipment.tabs.info">
              <div class="col-md-12">
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-location2"></i>
                    {{ $t("equipm.table.location") }}
                  </h4>
                </form>
                <!-- <div class="mobileTbl table-responsive">
                                        <table class="table table-hover mb-0" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.country')}}</th>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.region')}}</th>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.city')}}</th>
                                                    <th style="vertical-align: middle;">{{$t('equipm.table.street')}}</th>
                                                    <th style="vertical-align: middle; width: 8%">{{$t('equipm.table.number')}}</th>
                                                    <th style="vertical-align: middle; width: 10%">{{$t('equipm.table.index')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td :data-title="$t('equipm.table.country')">
                                                        <input type="text" id="country" class="form-control" name="country" v-model="dataEquipment.addressT.country" disabled="true">
                                                    </td>
                                                    <td :data-title="$t('equipm.table.region')">
                                                        <input type="text" id="region" class="form-control" name="region" v-model="dataEquipment.addressT.region" disabled="true">
                                                    </td>
                                                    <td :data-title="$t('equipm.table.city')">
                                                        <input type="text" id="city" class="form-control" name="city" v-model="dataEquipment.addressT.city" disabled="true">
                                                    </td>
                                                    <td :data-title="$t('equipm.table.street')">
                                                        <input type="text" id="street" class="form-control" name="street" v-model="dataEquipment.addressT.street" disabled="true">
                                                    </td>
                                                    <td :data-title="$t('equipm.table.number')">
                                                        <input type="text" id="streetN" class="form-control" name="streetN" v-model="dataEquipment.addressT.streetN" disabled="true">
                                                    </td>
                                                    <td :data-title="$t('equipm.table.index')">
                                                        <input type="text" id="index" class="form-control" name="index" v-model="dataEquipment.addressT.index" disabled="true">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> -->

                <div class="form-group col-md-8 mt-1 mb-0">
                  <input
                    type="text"
                    id="address_old"
                    name="address_old"
                    class="form-control border-primary"
                    v-model="dataEquipment.address"
                    readonly
                  />
                </div>
              </div>
            </div>

            <div class="row" v-if="dataEquipment.tabs.files">
              <div class="col-md-12">
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-file-text2"></i
                    >{{ $t("equipm.table.instructions") }}:
                  </h4>
                </form>
                <div class="form-group">
                  <div
                    class="col-md-12"
                    v-for="(file, index) in dataEquipment.instruсtions"
                    :key="index"
                  >
                    <a>
                      <h4 @click="bringfile(file.name)">
                        <img
                          :src="getIcon(file.name)"
                          style="max-height: 2rem; min-height: 1rem"
                        />
                        <span style="text-decoration: underline">{{
                          file.name
                        }}</span>
                      </h4>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-1" v-if="dataEquipment.tabs.photo">
              <div class="col-md-12">
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-images2"></i> {{ $t("tasks.table.images") }}
                  </h4>
                </form>

                <div class="row">
                  <div class="col-md-12" style="display: flex; flex-wrap: wrap">
                    <div
                      class="col-xs-3"
                      style="
                        padding: 0;
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        margin-bottom: 1em;
                      "
                      v-for="(image, index) in dataEquipment.ArrayPhoto"
                      :key="index"
                    >
                      <div
                        class="card hand mb-0"
                        style="margin-left: 5px"
                        @click="expandDiv(dataEquipment.ArrayPhoto, index)"
                      >
                        <div class="w-100 h-100 d-flex justify-content-center">
                          <img
                            v-bind:src="image"
                            style="max-width: 100%; max-height: 100%"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="row" v-if="dataEquipment.ArrayPhoto.length < dataEquipment.countPhoto">
                                        <div class="col-md-12">
                                            <form class="form-body">
                                                <div class="form-actions center mt-0 mb-0" style="padding: 0;">
                                                    <button type="button" class="btn btn-secondary" @click="loadPictures()"><i class="icon-download"></i> {{dataEquipment.ArrayPhoto.length + ' / ' + dataEquipment.countPhoto}}</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div> -->
              </div>
            </div>

            <div class="row" v-if="dataEquipment.tabs.history">
              <div class="col-md-12">
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-history"></i> {{ $t("titles.history") }}
                  </h4>
                </form>
                <div class="mobileTbl table-responsive">
                  <table class="table table-hover mb-0" cellspacing="0">
                    <thead>
                      <tr>
                        <th
                          class="text-truncate"
                          style="vertical-align: middle"
                        >
                          {{ $t("tasks.table.docNumb") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("tasks.table.date") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("tasks.table.status") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("tasks.table.execPers") }}
                        </th>
                        <th style="vertical-align: middle">
                          {{ $t("tasks.table.jobs") }}
                        </th>
                      </tr>
                    </thead>

                    <tbody
                      v-for="(eq, index) in dataEquipment.history"
                      :key="index"
                    >
                      <tr>
                        <td
                          class="text-truncate"
                          :data-title="$t('tasks.table.docNumb')"
                        >
                          {{ eq.DocNumber }}
                        </td>
                        <td
                          class="text-truncate"
                          :data-title="$t('tasks.table.date')"
                        >
                          {{ eq.Date }}
                        </td>
                        <td
                          class="text-truncate"
                          :data-title="$t('tasks.table.status')"
                        >
                          <span
                            class="tag"
                            :class="$t('tasks.' + eq.Status + '.class')"
                          >
                            {{ $t("tasks." + eq.Status + ".title") }}
                          </span>
                        </td>
                        <td :data-title="$t('tasks.table.execPers')" class="">
                          {{ eq.Executor }}
                        </td>
                        <td :data-title="$t('tasks.table.jobs')" class="">
                          {{ eq.JobS }}
                        </td>
                      </tr>
                      <tr v-if="eq.jobs != null">
                        <td></td>
                        <td colspan="4">
                          <span style="font-size: 0.8em">{{ eq.jobs }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
export default {
  name: "ModalEqInfo",
  data() {
    return {
      dataEquipment: {
        serial: "", //ме-20123469393
        guid: null,
        name: "",
        ExternalName: null,
        brand: "",
        ProductType: null,
        article: "",
        refrigerant: {
          weight: "",
          name: "",
        },
        address: null,
        addressChange: false,
        addressBefCH: null,
        addressT: {
          country: null,
          region: null,
          city: null,
          street: null,
          streetN: null,
          index: null,
        },
        components: [],
        dates: {
          manufacturing: "",
          shipment: "",
        },
        contacts: "",
        climaticClass: "",
        defrosting: "",
        lightning: "",
        maxPressure: "",
        protectionClass: "",
        ratedCurrent: "",
        ratedPinp: "",
        instruсtions: [],
        ArrayPhoto: [],

        images: [],
        images2: [],

        countLoad: 3,
        countPhoto: 0,

        tabs: {
          info: false,
          photo: false,
          files: false,
          history: false,
        },
        history: [],
      },
      modalArr: [],
      modalComp: {
        title: null,
        data: [],
        header: [],
      },
    };
  },
  components: {},
  props: {},
  methods: {
    changeForm() {
      //document.getElementsByClassName('v-modal__heading').style.padding = '0px';
      /*setTimeout( () => {
                    $('.v-modal__heading').css({"padding":"0px"});
                },500 
            );*/
    },
    closingModal() {
      this.dataEquipment.serial = null;
      this.dataEquipment.guid = null;
      this.dataEquipment.name = null;
      this.dataEquipment.ExternalName = null;
      this.dataEquipment.brand = null;
      this.dataEquipment.ProductType = null;
      this.dataEquipment.article = null;
      this.dataEquipment.refrigerant.weight = null;
      this.dataEquipment.refrigerant.name = null;
      this.dataEquipment.dates.manufacturing = null;
      this.dataEquipment.dates.shipment = null;
      this.dataEquipment.contacts = null;
      this.dataEquipment.climaticClass = null;
      this.dataEquipment.defrosting = null;
      this.dataEquipment.lightning = null;
      this.dataEquipment.maxPressure = null;
      this.dataEquipment.protectionClass = null;
      this.dataEquipment.ratedCurrent = null;
      this.dataEquipment.ratedPinp = null;

      this.dataEquipment.address = null;

      this.dataEquipment.addressT.country = null;
      this.dataEquipment.addressT.region = null;
      this.dataEquipment.addressT.city = null;
      this.dataEquipment.addressT.street = null;
      this.dataEquipment.addressT.streetN = null;
      this.dataEquipment.addressT.index = null;

      this.dataEquipment.components = [];
      this.dataEquipment.instruсtions = [];
      this.dataEquipment.ArrayPhoto = [];
      this.dataEquipment.countPhoto = 0;

      this.dataEquipment.images = [];
      this.dataEquipment.images2 = [];

      this.dataEquipment.tabs.info = false;
      this.dataEquipment.tabs.photo = false;
      this.dataEquipment.tabs.files = false;
      this.dataEquipment.tabs.history = false;

      this.dataEquipment.history = [];
    },
    getEqInfo(serial) {
      if (this.isValid(serial)) {
        this.closingModal();

        let dataRequest = {
          serial: serial,
          userGuid: this.$store.getters.getGuidUser,
          guidClient: this.$store.state.guidClient,
        };
        this.dataEquipment.serial = serial;

        this.makeQuery("/service/productSerialSite", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            this.dataEquipment.article = result.Articule;

            if (result.GUID != undefined) {
              this.dataEquipment.guid = result.GUID;
            }

            this.dataEquipment.ProductType = result.ProductType;
            if (this.dataEquipment.ProductType == "FMCG Refrigeration") {
              this.dataEquipment.ProductType = "Refrigeration";
            }

            if (result.Goods == "" || result.Goods == null) {
              this.dataEquipment.name =
                this.dataEquipment.ProductType +
                " (" +
                this.dataEquipment.serial +
                ")";
            } else {
              this.dataEquipment.name = result.Goods;
            }

            if (result.ExternalName != undefined) {
              this.dataEquipment.ExternalName = result.ExternalName;
            }

            this.dataEquipment.contacts = result.ContactInfo;

            this.dataEquipment.dates.manufacturing = this.dtFormat(
              result.DateOfProduction
            );
            this.dataEquipment.dates.shipment = this.dtFormat(
              result.DateOfShipment
            );

            this.dataEquipment.refrigerant.weight = result.RefrigerantMass;
            this.dataEquipment.refrigerant.name = result.RefrigerantBrand;
            this.dataEquipment.climaticClass = result.ClimaticClass;
            this.dataEquipment.defrosting = result.Defrosting;
            this.dataEquipment.lightning = result.Lightning;
            this.dataEquipment.maxPressure = result.MaxPressure;
            this.dataEquipment.protectionClass = result.ProtectionClass;
            this.dataEquipment.ratedCurrent = result.RatedCurrent;
            this.dataEquipment.ratedPinp = result.RatedPowerInput;

            this.dataEquipment.address = result.Adress;
            /*if((result.AdressSructure != undefined) && (result.AdressSructure != null)){
                        this.dataEquipment.addressT.country = result.AdressSructure.Country;
                        this.dataEquipment.addressT.region = result.AdressSructure.Region;
                        this.dataEquipment.addressT.city = result.AdressSructure.Location;
                        this.dataEquipment.addressT.street = result.AdressSructure.Street;
                        this.dataEquipment.addressT.streetN = result.AdressSructure.StreetN;
                        this.dataEquipment.addressT.index = result.AdressSructure.PostalCode;
                    }
                    this.dataEquipment.addressBefCH = Object.assign({}, this.dataEquipment.addressT);*/

            if (result.ItemStructure != undefined) {
              for (
                let index = 0;
                index < result.ItemStructure.length;
                index++
              ) {
                this.dataEquipment.components.push(result.ItemStructure[index]);
              }
            }

            if (result.quantityPhoto != undefined) {
              this.dataEquipment.countPhoto = result.quantityPhoto;
            }
            $(".v-modal__heading").css({ padding: "0px" });

            this.dataEquipment.tabs.info = true;
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      } else {
        this.showNotification(
          "custom-error",
          "Error",
          "Serial number can not be empty!"
        );
      }
    },
    bringfile(fileName) {
      for (let i = 0; i < this.dataEquipment.instruсtions.length; i++) {
        if (
          fileName == this.dataEquipment.instruсtions[i].name &&
          this.dataEquipment.instruсtions[i].data != null
        ) {
          fileDownload(this.dataEquipment.instruсtions[i].data, fileName);
          return;
        }
      }

      let dataRequest = {
        guid: dataEquipment.guid,
        serial: this.dataEquipment.serial,
        codeModel: this.dataEquipment.model,
        nameFile: fileName,
      };
      this.makeQuery("/service/getproductinctruction", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != null) {
            for (let i = 0; i < result.length; i++) {
              for (let j = 0; j < this.dataEquipment.instruсtions.length; j++) {
                if (
                  result[i].name == this.dataEquipment.instruсtions[j].name &&
                  (result[i].data != undefined || result[i].data != null)
                ) {
                  this.dataEquipment.instruсtions[j].data = this.base64String(
                    fileName,
                    result[i].data
                  ); // + result[i].data;
                  if (this.dataEquipment.instruсtions[j].data != null) {
                    fileDownload(
                      this.dataEquipment.instruсtions[j].data,
                      fileName
                    );
                    break;
                  } else {
                    this.showNotification(
                      "custom-info",
                      "Instructions",
                      "Not allowed Type of file " +
                        fileName +
                        ", contact Modern ASU!"
                    );
                    break;
                  }
                }
                if (
                  result[i].name == this.dataEquipment.instruсtions[j].name &&
                  (result[i].data == undefined || result[i].data == null)
                ) {
                  this.showNotification(
                    "custom-info",
                    "Instructions",
                    "No file there!"
                  );
                  break;
                }
              }
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    base64String(file, data) {
      let mediatype = "";

      const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      };

      if (file.indexOf(".xlsx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      } else if (file.indexOf(".xls") > -1) {
        mediatype = "application/vnd.ms-excel";
      } else if (file.indexOf(".txt") > -1) {
        mediatype = "text/plain";
      } else if (file.indexOf(".xml") > -1) {
        mediatype = "text/xml";
      } else if (
        file.indexOf(".png") > -1 ||
        file.indexOf(".jpg") > -1 ||
        file.indexOf(".jpeg") > -1 ||
        file.indexOf(".png") > -1
      ) {
        mediatype = "image/png";
      } else if (file.indexOf(".pdf") > -1) {
        mediatype = "application/pdf";
      } else if (file.indexOf(".doc") > -1) {
        mediatype = "application/msword";
      } else if (file.indexOf(".docx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else if (file.indexOf(".gz") > -1) {
        mediatype = "application/gzip";
      } else if (file.indexOf(".rar") > -1) {
        mediatype = "application/vnd.rar";
      } else if (file.indexOf(".tar") > -1) {
        mediatype = "application/x-tar";
      } else if (file.indexOf(".ppt") > -1) {
        mediatype = "application/vnd.ms-powerpoint";
      } else if (file.indexOf(".pptx") > -1) {
        mediatype =
          "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      } else if (file.indexOf(".vsd") > -1) {
        mediatype = "application/vnd.visio";
      } else if (file.indexOf(".zip") > -1) {
        mediatype = "application/zip";
      }

      if (mediatype != "") {
        return b64toBlob(data, mediatype); //'data:' + mediatype + ';base64,';
      } else {
        return null;
      }
    },
    expandDiv(arr, ind) {
      if (arr[0].data != undefined) {
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          arr2.push(arr[i].data);
        }
        arr = arr2;
      }

      $("#modalImg2").modal("show");
      this.$refs.imgzoomC.onShow(ind, arr);
    },
    loadPictures() {
      if (this.dataEquipment.ArrayPhoto.length < 1) {
        let dataRequest = {
          serial: this.dataEquipment.serial,
          client: this.$store.state.listRole.client,
          guid: this.dataEquipment.guid,
        };

        this.makeQuery2("/service/getProductImage", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            let arr_img = [],
              mark_old = false;

            if (
              result &&
              result.data &&
              result.data.signed_urls &&
              Array.isArray(result.data.signed_urls)
            ) {
              arr_img = result.data.signed_urls;
            }
            if (
              result &&
              result.data &&
              result.data.data &&
              Array.isArray(result.data.data)
            ) {
              arr_img = result.data.data;
              mark_old = true;
            }
            if (arr_img.length) {
              for (let i = 0; i < arr_img.length; i++) {
                if (mark_old) {
                  this.dataEquipment.ArrayPhoto.push(arr_img[i] + "/preview");
                } else {
                  this.dataEquipment.ArrayPhoto.push(arr_img[i].url);
                }
              }
            }
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    loadHistory() {
      this.dataEquipment.history = [];
      let dataRequest = {
        number: this.dataEquipment.serial,
        guid: this.dataEquipment.guid,
      };

      this.makeQuery("/service/getHistoryTask", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != undefined && result.length > 0) {
            for (let i = 0; i < result.length; i++) {
              if (result[i].Date != null) {
                result[i].Date = this.dtFormat(result[i].Date);
              }

              if (result[i].Date != null) {
                result[i].StatusTXT = result[i].Status;

                //set status translate
                if (result[i].StatusBP == 1) {
                  //СогласованиеЗаявки
                  result[i].Status = "statuses.new";
                } else if (result[i].StatusBP == 2) {
                  result[i].Status = "statuses.agreed";
                } else if (result[i].StatusBP == 3) {
                  //ВыполнениеЗаявки
                  result[i].Status = "statuses.process";
                } else if (result[i].StatusBP == 4) {
                  //ВнесениеЗатрат
                  result[i].Status = "statuses.finish";
                } else if (result[i].StatusBP == 5) {
                  result[i].Status = "statuses.done";
                } else if (result[i].StatusBP == 6) {
                  result[i].Status = "statuses.cancel";
                }

                if (this.isValid(result[i].Comment)) {
                  result[i].jobs = result[i].Comment;
                } else {
                  result[i].jobs = null;
                }

                this.dataEquipment.history.push(result[i]);
              }
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    loadInstructions() {
      let dataRequest = {
        serial: this.dataEquipment.serial,
        guid: this.dataEquipment.guid,
      };
      this.makeQuery("/service/getProductFile", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          this.dataEquipment.instruсtions = [];

          for (let i = 0; i < result.length; i++) {
            if (result[i] != null) {
              this.dataEquipment.instruсtions.push({
                name: result[i],
                data: null,
              });
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    showComponDetail(event, el) {
      let dataRequest = {
        serial: el.ItemSN,
        guid: this.dataEquipment.guid,
        userGuid: this.$store.getters.getGuidUser,
      };

      console.log(event);
      //ме-21083544576
      this.makeQuery("/service/getInfoComponents", {
        dataRequest: dataRequest,
        token: this.$store.getters.getUserToken,
      })
        .then((result) => {
          if (result != null) {
            if (result.length > 0) {
              this.modalComp.data = result;
              //let w=$('#SerialComp').attr('style').split(';')[0].replace(/\D/g,'');
              let w = $("#SerialComp").width();
              var tooltipX = event.pageX - 8 - Math.floor(w);
              var tooltipY = event.pageY + 15;
              $("#SerialComp").css({ top: tooltipY, left: tooltipX });
              $("#SerialComp").css({ display: "block" });

              this.modalComp.title = el.Item;
              this.modalComp.header = Object.keys(this.modalComp.data[0]);
            } else {
              this.showNotification(
                "custom-info",
                this.$t("equipm.titles.components"),
                this.$t("titles.nodata")
              );
            }
          }
        })
        .catch((result) => {
          this.showNotification("custom-error", "Error", result);
        });
    },
    closeSerCompon() {
      $("#SerialComp").css({ display: "none" });
      this.modalComp.data = [];
      this.modalComp.title = null;
      this.modalComp.header = [];
    },
  },
  computed: {
    titleRefr: function () {
      let a = "",
        b = "";
      if (this.dataEquipment.refrigerant.name) {
        a = this.dataEquipment.refrigerant.name;
      }
      if (this.dataEquipment.refrigerant.weight) {
        b = " (" + this.dataEquipment.refrigerant.weight + ")";
      }
      return a + b;
    },
  },
  mounted() {},
  watch: {
    "dataEquipment.tabs.info": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.photo = false;
        this.dataEquipment.tabs.files = false;
        this.dataEquipment.tabs.history = false;
      }
    },
    "dataEquipment.tabs.photo": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.info = false;
        this.dataEquipment.tabs.files = false;
        this.dataEquipment.tabs.history = false;

        // if( (this.dataEquipment.ArrayPhoto.length < 1) && (this.dataEquipment.countPhoto > 0) ){
        //     this.loadPictures();
        // }
        this.loadPictures();
      }
    },
    "dataEquipment.tabs.files": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.info = false;
        this.dataEquipment.tabs.photo = false;
        this.dataEquipment.tabs.history = false;

        this.loadInstructions();
      }
    },
    "dataEquipment.tabs.history": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.info = false;
        this.dataEquipment.tabs.photo = false;
        this.dataEquipment.tabs.files = false;

        if (this.dataEquipment.history.length < 1) {
          this.loadHistory();
        }
      }
    },
  },
  created() {},
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ModalEqInfo.vue